import { z } from 'zod';
import { panelLineStateSchema } from './panelLineStateSchema';

export const mapDetailSchema = z.object({
  lat: z.number(),
  lng: z.number(),
  panels: z.array(panelLineStateSchema),
});

export type MapDetailState = z.infer<typeof mapDetailSchema>;
